import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
import { IMAGE_HEIGHT, IMAGE_WIDTH } from "./OrderCard.definition";

const DISABLED_ITEM_BORDER_COLOR = "black";

const style = () => {
  const {
    borderRadius3,
    borderWidth2,
    colorBorderInput,
    colorBorderInteractive,
    space05,
    space1,
    space2,
    space4,
    space6,
    colorTextMedium,
    colorTextMediumLight,
  } = theme();

  return StyleSheet.create({
    date: {
      color: colorTextMedium,
      marginBottom: space05,
    },
    disabledItem: {
      borderColor: DISABLED_ITEM_BORDER_COLOR,
    },
    footer: {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    item: {
      borderColor: colorBorderInput,
      borderRadius: borderRadius3,
      borderWidth: borderWidth2,
      marginHorizontal: space1,
      overflow: "hidden",
    },
    items: {
      flexDirection: "row",
      marginVertical: space6,
    },
    order: {
      paddingVertical: space4,
    },
    otherProductsText: {
      color: colorTextMediumLight,
      textAlign: "center",
    },
    otherProductsWrapper: {
      alignItems: "center",
      borderColor: colorBorderInteractive,
      borderRadius: borderRadius3,
      borderWidth: borderWidth2,
      height: IMAGE_HEIGHT + borderWidth2 * 2,
      justifyContent: "center",

      marginLeft: space1,
      width: IMAGE_WIDTH + borderWidth2 * 2,
    },
    referenceText: {
      color: colorTextMedium,
    },
    status: {
      paddingHorizontal: space2,
      paddingVertical: space05,
    },
    unavailableItem: {
      borderWidth: 0,
    },
    unavailableItemImage: {
      opacity: 0.4,
    },
  });
};

export { style };
